@for (notification of notifications$ | async; track $index; let first = $first; let last = $last; let i = $index) {
  @if (notification?.text?.label | finLocalization: notification.text.params; as notificationText) {
    <fcom-notification
      [theme]="notification.theme"
      [iconName]="notification.icon"
      [removeHorizontalPadding]="notification.removePadding"
      class="block"
      [class.ps-medium-t]="first"
      [class.pr-xxsmall-b]="!last"
      [attr.data-testid]="'booking-widget-notification-' + notification.type"
    >
      @if (!isAm()) {
        <p data-testid="bw-notification-text" [innerHTML]="notificationText | resolveLinks | finSafe: 'html'"></p>
        @if (notification?.text1?.label | finLocalization; as notificationSecondaryText) {
          <p [innerHTML]="notificationSecondaryText | resolveLinks | finSafe: 'html'"></p>
        }
        @if (notification?.link) {
          <a
            [finLink]="
              notification.link.url.startsWith('/')
                ? (notification.link.url | resolveLinks)
                : (notification.link.url | finLocalization | resolveLinks)
            "
            [external]="!!notification.link?.external"
            [openInNewTab]="!!notification.link?.openInNewTab"
            [attr.rel]="'noreferrer'"
            class="underline link-hover nordic-blue-900-text text-icon-primary mr-xsmall-t block font-label-medium"
            data-testid="booking-widget-notification-link"
          >
            <span class="ms-xxsmall-r">{{ notification.link?.text | finLocalization }}</span>
            @if (notification.link?.external) {
              <fcom-icon class="external-link icon-medium" [name]="SvgLibraryIcon.EXTERNAL_TAB" />
            }
          </a>
        }
      }
      @if (isAm()) {
        <fin-expand #expand [key]="'notification-' + i" [id]="'notification-' + i" [initiallyOpen]="false">
          <div class="trigger flex flex--center">
            <div class="flex flex-1 flex--middle mr-xsmall-r">
              <span class="font-body-medium" [innerHTML]="notificationText | resolveLinks | finSafe: 'html'"></span>
            </div>
            <fcom-icon
              class="flex-1 flex--nogrow rotate icon-medium"
              [class.rotate-active]="expand.isOpen$ | async"
              [name]="SvgLibraryIcon.CHEVRON_DOWN"
            />
          </div>
          @if (notification?.text1?.label | finLocalization; as notificationSecondaryText) {
            <div class="content">
              @if (expand.isOpen$ | async) {
                <div
                  class="ps-xsmall-t font-body-medium"
                  [innerHTML]="notificationSecondaryText | resolveLinks | finSafe: 'html'"
                ></div>
              }
            </div>
          }
        </fin-expand>
      }
    </fcom-notification>
  }
}
